export default "__VITE_ASSET__gR1CRv2B__"